import React from "react";
import { array, func } from "prop-types";
import { Box, Button, Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VideoCard from "./VideoCard";
import VideoPlayer from "./details/VideoPlayer";

const propsAreSame = (preProps, nextProps) => {
  return preProps.videos && nextProps.videos && preProps.videos.length === nextProps.videos.length;
};

const Videos = React.memo(function Videos({ videos, handleSelectVideo, Header = null }) {
  return (
    <>
      {Header && <Header />}
      <Stack
        direction="row"
        sx={{
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {videos.map((video, i) => (
          <Box
            key={i}
            component="article"
            sx={{
              flex: {
                xs: "0 0 100%",
                sm: "0 0 calc(50% - 8px)",
                lg: "0 0 calc(33.333% - 10.67px)",
              },
              display: "flex",
              alignItems: "stretch",
              minWidth: 0,
            }}
          >
            <VideoCard video={video} handleClick={handleSelectVideo} />
          </Box>
        ))}
      </Stack>
    </>
  );
}, propsAreSame);

Videos.propTypes = {
  videos: array.isRequired,
  handleSelectVideo: func.isRequired,
  Header: func,
};

class VideoGrid extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      activeVideo: {
        title: "",
        id: "",
      },
    };
  }

  render() {
    const { videos } = this.props;
    const { activeVideo } = this.state;

    const handleSelectVideo = (resource) => {
      this.setState((prevState) => ({
        ...prevState,
        modalOpen: true,
        activeVideo: {
          title: resource.title,
          id: resource.youtube_id,
          description: resource.description,
          tags: resource.platform_tags,
        },
      }));
    };
    const handleModalClose = () => {
      this.setState({
        activeVideo: { title: "", id: "", tags: [], description: "" },
        modalOpen: false,
      });
    };

    return (
      <>
        <Videos videos={videos} handleSelectVideo={handleSelectVideo} />
        <Dialog fullWidth maxWidth="md" open={this.state.modalOpen} onClose={handleModalClose}>
          <DialogActions style={{ paddingBottom: 0 }}>
            <Button variant="text" onClick={handleModalClose} startIcon={<CloseIcon />}>
              Close
            </Button>
          </DialogActions>
          <DialogContent>
            <div style={{ minHeight: "550px" }}>
              {activeVideo.id && <VideoPlayer video={activeVideo} isFeatured={true} />}
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

VideoGrid.propTypes = {
  videos: array,
  handleSelectVideo: func,
  Header: func,
};

export default VideoGrid;
